module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p13-B-6635d4306eea1ccda345c477f4db49b5.png";